import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRLanding = () => {
  const url = `${window.location.origin}/`;
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="d-flex flex-column gap-3 align-items-center">
        <h5>Scan the QR Code</h5>
        <QRCodeCanvas
          value={url} // The URL to encode
          size={200} // Size of the QR code
          bgColor="#ffffff" // Background color
          fgColor="#000000" // Foreground color
          level="H" // Error correction level
        />
        <h6 className="text-center">{url}</h6>
      </div>
    </div>
  );
};

export default QRLanding;
